import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { DashboardChangeHistoriesRoute } from '../../routing'

export  class DashboardChangeHistoriesPage extends Component {
    render() {
        return (
            <Fragment>
            <Breadcrumbs />
            <DashboardChangeHistoriesRoute />
        </Fragment>
        )
    }
}